import {Model} from '@vuex-orm/core';
import {Answer, Area, AreaQuestion, ExplanationFigure, Figure, Licence, LicenceQuestion, QuestionFigure, SubArea, SubAreaQuestion, Subject, SubjectQuestion} from '.';

export class Question extends Model {
  static entity = 'questions';

  static fields() {
    return {
      id: this.attr(null),
      number: this.attr(''),
      language: this.attr(''),
      text: this.attr(''),
      explanation: this.attr(''),
      answers: this.hasMany(Answer, 'questionId'),
      licences: this.belongsToMany(Licence, LicenceQuestion, 'questionId', 'licenceId'),
      subjects: this.belongsToMany(Subject, SubjectQuestion, 'questionId', 'subjectId'),
      areas: this.belongsToMany(Area, AreaQuestion, 'questionId', 'areaId'),
      subAreas: this.belongsToMany(SubArea, SubAreaQuestion, 'questionId', 'subAreaId'),
      figures: this.belongsToMany(Figure, QuestionFigure, 'questionId', 'figureId'),
      explanationFigures: this.belongsToMany(Figure, ExplanationFigure, 'questionId', 'figureId'),

      createdAt: this.attr(''),
      updatedAt: this.attr(''),
    };
  }

  id: number;
  number: string;
  language: string;
  text: string;
  explanation: string;
  answers: Answer[];
  licences: Licence[];
  subjects: Subject[];
  areas: Area[];
  subAreas: SubArea[];
  figures: Figure[];
  explanationFigures: Figure[];

  createdAt: string;
  updatedAt: string;
}
